export default __webpack_public_path__ + "static/media/empty_permissions_tab.12de4f1a.svg";